const REQUIRED_FIELD_MESSAGES = {
  client_phone: "Укажите номер телефона",
  client_address: "Укажите адрес подключения",
}

export default function ContactForm() {
  return `
      <form id="contact-form" class="form" method="post" novalidate>
         <h2 class="form-title">ЗАЯВКА НА ПОДКЛЮЧЕНИЕ</h2>
         <div class="form-field" aria-hidden="true" style="position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;">
              <label for="company_site">Company site</label>
              <input id="company_site" name="company_site" type="text" tabindex="-1" autocomplete="off">
         </div>
         <input type="hidden" name="form_started_at" value="${Date.now()}">
         <div class="form-group">
             <div class="form-field">
                  <input id="name" name="client_name" type="text" placeholder="Имя" autocomplete="name">
             </div>
             <div class="form-field">
                  <input id="phone" name="client_phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="+7 000 000 00 00" maxlength="16" required>
             </div>
             <div class="form-field address-field">
                  <input id="address" name="client_address" type="text" placeholder="Адрес" autocomplete="street-address" required>
              </div>
             <div class="form-field">
                  <textarea id="comment" name="client_comment" placeholder="Комментарий к заявке"></textarea>
             </div>
             <div class="form-checkboxes">
                  <input type="checkbox" id="agreement" name="agreement_pd">
                  <label for="agreement">Даю согласие на обработку персональных данных</label>
             </div>
             <div class="form-checkboxes">
                  <input type="checkbox" id="agreement_terms" name="agreement_terms">
                  <label for="agreement_terms">Согласен с <a href="/politics" target="_blank">политикой конфиденциальности</a> и <a href="/rules" target="_blank">правилами использования сервиса</a></label>
             </div>
         </div>

         <div class="form-actions">
             <button type="submit" class="button btn-primary">Подключить</button>
             <button type="button" class="button btn-light" data-close-modal>Отмена</button>
         </div>
      </form>
   `
}

function normalizePhoneDigits(value) {
  let digits = value.replace(/\D/g, "")

  if (!digits) {
    return ""
  }

  if (digits.startsWith("8")) {
    digits = `7${digits.slice(1)}`
  }

  if (!digits.startsWith("7")) {
    digits = `7${digits}`
  }

  return digits.slice(0, 11)
}

function formatPhoneValue(value) {
  const digits = normalizePhoneDigits(value)

  if (!digits) {
    return ""
  }

  const countryCode = "+7"
  const cityCode = digits.slice(1, 4)
  const firstPart = digits.slice(4, 7)
  const secondPart = digits.slice(7, 9)
  const thirdPart = digits.slice(9, 11)

  let formattedValue = countryCode

  if (cityCode) {
    formattedValue += ` ${cityCode}`
  }

  if (firstPart) {
    formattedValue += ` ${firstPart}`
  }

  if (secondPart) {
    formattedValue += ` ${secondPart}`
  }

  if (thirdPart) {
    formattedValue += ` ${thirdPart}`
  }

  return formattedValue
}

function setFieldError(field, message) {
  const fieldWrapper = field.closest(".form-field")

  fieldWrapper?.classList.add("is-invalid")
  field.setAttribute("aria-invalid", "true")
  field.setAttribute("title", message || "")
}

function clearFieldError(field) {
  const fieldWrapper = field.closest(".form-field")

  fieldWrapper?.classList.remove("is-invalid")
  field.removeAttribute("aria-invalid")
  field.removeAttribute("title")
}

function validateField(field) {
  const value = field.value.trim()

  if (field.name === "client_phone") {
    const phoneDigits = normalizePhoneDigits(field.value)

    if (phoneDigits.length !== 11) {
      setFieldError(field, REQUIRED_FIELD_MESSAGES[field.name])
      return false
    }
  }

  if (field.name === "client_address" && !value) {
    setFieldError(field, REQUIRED_FIELD_MESSAGES[field.name])
    return false
  }

  clearFieldError(field)
  return true
}

function setupPhoneMask(phoneInput) {
  if (!phoneInput) {
    return
  }

  phoneInput.addEventListener("focus", () => {
    if (!phoneInput.value) {
      phoneInput.value = "+7"
    }
  })

  phoneInput.addEventListener("input", () => {
    phoneInput.value = formatPhoneValue(phoneInput.value)
  })

  phoneInput.addEventListener("blur", () => {
    if (normalizePhoneDigits(phoneInput.value).length <= 1) {
      phoneInput.value = ""
    }
  })
}

export function initContactForm(container) {
  const form = container.querySelector("#contact-form")

  if (!form) {
    return
  }

  const phoneInput = form.querySelector('input[name="client_phone"]')
  const requiredFields = Array.from(
    form.querySelectorAll(
      'input[name="client_phone"], input[name="client_address"]',
    ),
  )

  setupPhoneMask(phoneInput)

  requiredFields.forEach((field) => {
    field.addEventListener("input", () => validateField(field))
    field.addEventListener("blur", () => validateField(field))
  })
}
